"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles2 = require("../utilities/styles");
var _button = _interopRequireDefault(require("../button"));
var _image = _interopRequireDefault(require("../image"));
const _excluded = ["src", "alt", "role", "children", "imageWrapperSelector", "classes", "ImageProps", "imageChildren", "variant"],
  _excluded2 = ["image", "imageWrapper"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const useStyles = (0, _styles.makeStyles)(({
  palette,
  breakpoints
}) => ({
  root: ({
    imageWrapperSelector,
    variant
  }) => ({
    display: 'block',
    padding: 0,
    [`& ${imageWrapperSelector}`]: {
      position: 'relative'
    },
    [`&:hover ${imageWrapperSelector}::before, &:focus ${imageWrapperSelector}::before`]: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      border: `4px solid ${palette[variant].main}`,
      zIndex: 1
    },
    [`&:hover ${imageWrapperSelector}::before`]: {
      [breakpoints.down('sm')]: {
        border: 'none'
      }
    }
  })
}), {
  classNamePrefix: 'TCUIImageButton'
});
const ImageButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      src,
      alt,
      children,
      imageWrapperSelector,
      classes,
      ImageProps,
      imageChildren,
      variant
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const _classes = useStyles({
    imageWrapperSelector,
    variant
  });
  const {
      image,
      imageWrapper
    } = classes,
    restClasses = (0, _objectWithoutPropertiesLoose2.default)(classes, _excluded2);
  const wrapperProps = (0, _extends2.default)({}, rest, {
    ref: ref,
    classes: (0, _styles2.mergeClasses)({
      root: _classes.root
    }, restClasses)
  });
  const InnerContent = () => {
    if (!!children) return children;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)('image-wrapper', imageWrapper)
    }, /*#__PURE__*/_react.default.createElement(_image.default, (0, _extends2.default)({}, ImageProps, {
      src: src,
      alt: alt,
      className: (0, _clsx.default)(image, ImageProps.className)
    })), imageChildren);
  };
  return /*#__PURE__*/_react.default.createElement(_button.default, wrapperProps, /*#__PURE__*/_react.default.createElement(InnerContent, null));
});
ImageButton.propTypes = {
  classes: _propTypes.default.object,
  children: _propTypes.default.node,
  imageWrapperSelector: _propTypes.default.string,
  href: _propTypes.default.string,
  src: _propTypes.default.string,
  alt: _propTypes.default.string,
  ImageProps: _propTypes.default.object,
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),
  imageChildren: _propTypes.default.node
};
ImageButton.defaultProps = {
  ImageProps: {},
  classes: {},
  children: null,
  imageWrapperSelector: '.image-wrapper',
  href: null,
  src: null,
  alt: null,
  variant: 'primary',
  imageChildren: null
};
var _default = exports.default = ImageButton;